import {
  defaultToolTip,
  xAxisStyleDefault,
  fontColor,
  // tooltopBgColor,
} from '../config';
import D_Number from '@utils/number';
export const pointBreakColumn = function (e) {
  const that = this;
  const point = e.point,
    brk = e.brk,
    shapeArgs = point.shapeArgs,
    x = shapeArgs.x,
    y = that.translate(brk.from, 0, 1, 0, 1),
    w = shapeArgs.width,
    key = ['brk', brk.from, brk.to],
    path = [
      'M',
      x,
      y,
      'L',
      x + w * 0.25,
      y + 4,
      'L',
      x + w * 0.75,
      y - 4,
      'L',
      x + w,
      y,
    ];
  if (!point.y) {
    point[key] = null;
  }
  if (!point[key]) {
    point[key] = that.chart.renderer
      .path(path)
      .attr({
        'stroke-width': 2,
        stroke: point.series.options.borderColor,
      })
      .add(point.graphic.parentGroup);
  } else {
    point[key].attr({
      d: path,
    });
  }
};
export const defaultWaterfallChartOption = {
  chart: {
    type: 'waterfall',
    // backgroundColor: '#fff',
    // width:
    //   document.body.clientWidth < 1080
    //     ? 898
    //     : document.body.clientWidth - 84 - 130,
    // styleMode: true,
    className: 'waterfall-chart',
    style: {
      fontFamily: 'Helvetica Neue, Arial, sans-serif',
    },
    marginLeft: 50,
    marginRight: 20,
    marginBottom: 70,
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    ...defaultToolTip,
    backgroundColor: 'rgba(0,0,0,0.72)',
    outside: true,
    useHTML: true,
    className: 'value-driver-tooltip',
  },
  title: {
    align: 'left',
    text: 'Value Bridge',
    x: 10,
    y: 20,
    style: {
      fontSize: '1.25rem',
      color: 'var(--valueDriverChartTitleColor)',
    },
  },
  subtitle: {
    align: 'left',
    text: 'In USD ‘000s',
    x: 11,
    y: 40,
    style: {
      fontSize: '0.75rem',
      color: 'var(--fontColorLevel3)',
    },
  },
  xAxis: {
    type: 'category',
    color: 'blue',
    showEmpty: true,
    labels: {
      style: {
        ...xAxisStyleDefault,
        color: 'var(--fontColorLevel3)',
        useHTML: true,
      },
    },
    lineColor: 'var(--valueDriverChartXAxisColor)',
  },

  yAxis: {
    // visible: false,
    tickInterval: 100,
    gridLineColor: 'var(--valueDriverChartYAxisGridColor)',
    lineColor: '#fff',
    labels: {
      formatter() {
        // console.log(this.value);
        if (this.value !== 0) {
          return null;
        }
        return this.value;
      },
    },
    title: {
      text: '',
    },
    // type: 'logarithmic',
    // minorTickInterval: 0.1,
    // accessibility: {
    //   rangeDescription: 'Range: 0.1 to 1000',
    // },
  },
  plotOptions: {
    waterfall: {
      maxPointWidth: 50,
      dataLabels: {
        style: {
          color: fontColor,
        },
        enabled: true,
        verticalAlign: 'top',
        y: -25,
        formatter() {
          //   console.log(this);
          return D_Number.formatWithoutSuffix(this.y);
        },
      },
    },
    series: {
      minPointLength: 2,
    },
  },
  series: [
    {
      dashStyle: 'dash',
      lineColor: '#999999',

      pointPadding: 0,
      data: [],
    },
  ],
};
export const shouldBreakColumn = (list, ebitLabel) => {
  if (Array.isArray(list) && list?.length) {
    const combineEbit = list.find(
      (i) => i.name === `Combined ${ebitLabel}` && i.y > 0,
    );
    if (combineEbit) {
      const breakRange = [combineEbit.y * 0.1, combineEbit.y * 0.9];
      let currentYAxisValue = combineEbit.y;
      for (let i = 0; i < list.length; i++) {
        // if([`Buyer ${ebitLabel}`, `Target ${ebitLabel}`, `Combined ${ebitLabel}`].includes(list[i].name)) continue;
        if (list[i].y === null || !list[i].others?.isItem) {
          continue;
        }
        const columnTop = currentYAxisValue;
        const columnBottom = currentYAxisValue + list[i].y;
        const isBreakRangeContainColumn =
          columnBottom >= breakRange[0] && columnTop <= breakRange[1];
        const isBreakRangeOverlapColumn =
          (columnBottom >= breakRange[0] && columnBottom <= breakRange[1]) ||
          (columnTop <= breakRange[1] && columnTop >= breakRange[0]);
        if (isBreakRangeContainColumn || isBreakRangeOverlapColumn) {
          return false;
        }
        currentYAxisValue = columnBottom;
      }

      return true;
    }
  }
  return false;
};
